"use client";

var __jsx = React.createElement;
import React, { Fragment, useRef } from "react";
import { Transition } from "@headlessui/react";
import useOnClickOutside from "@lib/hooks/use-onclick-outside";
import useAppearInsideScreen from "@lib/hooks/use-appear-inside-screen";
import { cn } from "@lib/cn";
const MuscleFlyOverPanel = _ref => {
  let {
    align = "center",
    isOpen,
    setIsOpen,
    children,
    buttonRef,
    containerClassName
  } = _ref;
  const panelRef = useRef(null);
  useOnClickOutside(buttonRef ? [panelRef, buttonRef] : panelRef, () => {
    setIsOpen(false);
  }, isOpen);
  useAppearInsideScreen(panelRef, isOpen);
  const getAlignmentClassName = () => {
    switch (align) {
      case "center":
        return "left-1/2 -translate-x-1/2";
      case "left":
        return "left-0";
      case "right":
        return "right-0";
    }
  };
  return __jsx("div", {
    className: "relative h-0 z-[500]"
  }, __jsx(Transition, {
    show: isOpen,
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, __jsx("div", {
    ref: panelRef,
    className: cn("absolute z-10 mt-0 top-1 min-w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none " + getAlignmentClassName() + ' w-fit', containerClassName)
  }, __jsx("div", {
    className: "py-1"
  }, children))));
};
export default MuscleFlyOverPanel;